exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".navbar-menu-buscador{margin:20px auto 0}.navbar-menu-buscador nav.navbar.navbar-inverse{height:80px;padding-right:0;background-color:#004282;border-radius:0}.navbar-menu-buscador nav.navbar.navbar-inverse>.container{width:100%;max-width:100%}.navbar-menu-buscador nav.navbar.navbar-inverse .navbar-right{margin-right:5px;align-items:baseline;float:right!important}.current-filter-value{color:#fff;font-size:13px;font-weight:300;padding:0;margin:0;display:inline-block}@media (max-width:768px){.navbar-menu-buscador{margin-top:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/features/commons/Menu/SearchMenu/SearchMenu.scss
// module id = 653
// module chunks = 0